import { render, staticRenderFns } from "./StudentSkill.vue?vue&type=template&id=700b47dc&"
import script from "./StudentSkill.vue?vue&type=script&lang=js&"
export * from "./StudentSkill.vue?vue&type=script&lang=js&"
import style0 from "./StudentSkill.vue?vue&type=style&index=0&id=700b47dc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports